import { IconSvg, IconSvgProps } from "./icon"

export default function Bell(props: IconSvgProps) {
  return (
    <IconSvg {...props}>
      <path d="m16.4894 5.67793c1.1903 1.19024 1.859 2.80454 1.859 4.48777v7.3044h-12.6934v-7.3044c0-1.68323.66867-3.29753 1.85891-4.48777 1.19023-1.19023 2.80449-1.8589 4.48779-1.8589 1.6832 0 3.2975.66867 4.4877 1.8589z" />
      <path
        d="m10.0017 18.4291c0 .4932.2107.9662.5858 1.315.3751.3487.8838.5447 1.4142.5447s1.0391-.196 1.4142-.5447c.3751-.3488.5858-.8218.5858-1.315"
        fill="none"
      />
    </IconSvg>
  )
}
